import { Injectable } from '@angular/core'
import { GlobalMessageService, GlobalMessageType, Translatable } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class CustomGlobalMessageService extends GlobalMessageService {
  add(text: string | Translatable, type: GlobalMessageType, timeout: number = 5000) {
    super.add(text, type, timeout)
  }
}
